import React from "react";
import "../../App.css";
import HeroSection from "../HeroSection";
// import Cards from "../Cards";

import Advert from "../Advert";
// import CarouselPage from "../Carousel/CarouselPage";

function Home() {
  return (
    <>
      <HeroSection />
      {/* <CarouselPage /> */}
      {/* <Cards /> */}
      <Advert />
    </>
  );
}
export default Home;
